import { Provider } from "@agrigate/shared-web-ui/lib/components/ui/provider";
import { Toaster } from "@agrigate/shared-web-ui/lib/components/ui/toaster";
import { useHashRouteRedirect } from "@agrigate/shared-web-ui/lib/hooks/use-hash-route-redirect";
import ReactRouterAdapter from "@agrigate/shared-web-ui/lib/utils/qparams-react-router-adapter";
import { type ReactElement, Suspense } from "react";
import { useRoutes } from "react-router";
import { QueryParamProvider } from "use-query-params";
import routes from "~react-pages";

export default function App(): ReactElement | null {
    const routeView = useRoutes(routes);

    useHashRouteRedirect();

    return (
        <Provider>
            <QueryParamProvider adapter={ReactRouterAdapter}>
                <Suspense fallback={<p>Loading...</p>}>{routeView}</Suspense>
            </QueryParamProvider>
            <Toaster />
        </Provider>
    );
}
